var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1.5L16 1.5V3.1L4 3.1V1.5ZM0 7L16 7V8.6L0 8.6L0 7ZM16 12.5L4 12.5V14.1L16 14.1V12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenu);
export default __webpack_public_path__ + "static/media/ic-menu.11241ad37cba6cce3002ad99bafa86a2.svg";
export { ForwardRef as ReactComponent };